import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

const baseStyle = defineStyle({
  borderColor: 'gray.200',
  opacity: 1
});

export const Divider = defineStyleConfig({
  baseStyle
});